import useSelectedResort from "@/hooks/useSelectedResort"
import {
  useBookingLengthParam,
  useCategoryParam,
  useDateParam,
} from "@/hooks/useSkipassFlow"
import useBookingLengths from "@/queries/hooks/useBookingLengths"

const useSelectedBookingLength = () => {
  const { bookingLengthId } = useBookingLengthParam()
  const { categoryId } = useCategoryParam()
  const { selectedResort } = useSelectedResort()
  const { startDate } = useDateParam()

  const {
    data: bookingLengths,
    isLoading,
    isError,
  } = useBookingLengths(selectedResort?.id, categoryId, startDate)

  const selectedBookingLength = bookingLengths?.find(
    (bl) => bl.id === bookingLengthId
  )

  return { selectedBookingLength, bookingLengths, isLoading, isError }
}

export default useSelectedBookingLength
